import React from 'react';

/**
 * StatusTag — renders .tag with correct color class
 */
export function StatusTag({ status }) {
  const s = String(status || '').toUpperCase();
  let cls = 'tag-gray';
  if (s === 'RETURNED' || s === 'IN' || s === 'APPROVED' || s === 'ACTIVE' || s === 'SIGNED_BY_SUPERVISOR' || s === 'RESOLVED') cls = 'tag-green';
  else if (s === 'ACCEPTED' || s === 'PENDING' && false) cls = 'tag-blue';
  else if (s === 'ACCEPTED') cls = 'tag-blue';
  else if (s === 'PENDING') cls = 'tag-orange';
  else if (s === 'OUT' || s === 'REFUSED' || s === 'REJECTED' || s === 'SIGNED_BY_STUDENT' || s === 'OPEN') cls = 'tag-orange';
  else if (s === 'IN_PROGRESS') cls = 'tag-blue';
  else if (s === 'CLOSED') cls = 'tag-gray';
  return <span className={`tag ${cls}`}>{s || '-'}</span>;
}

/**
 * StudentStatusTag — IN=green, OUT=orange
 */
export function StudentStatusTag({ status }) {
  const s = String(status || '').toUpperCase();
  const cls = s === 'IN' ? 'tag-green' : s === 'OUT' ? 'tag-orange' : 'tag-gray';
  return <span className={`tag ${cls}`}>{s || '-'}</span>;
}

/**
 * OnlineDot — green/grey status dot
 */
export function OnlineDot({ online }) {
  return <span className={`status-dot ${online ? 'online' : 'offline'}`}>{online ? 'En ligne' : 'Hors ligne'}</span>;
}

/**
 * ViewIcon, QrIcon, CheckInIcon, CheckOutIcon, ApproveIcon, RefuseIcon
 */
export const ViewIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);
export const QrIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="5" height="5" x="3" y="3" rx="1"/><rect width="5" height="5" x="16" y="3" rx="1"/>
    <rect width="5" height="5" x="3" y="16" rx="1"/>
    <path d="M21 16h-3a2 2 0 0 0-2 2v3"/><path d="M21 21v.01"/>
    <path d="M12 7v3a2 2 0 0 1-2 2H7"/><path d="M3 12h.01"/><path d="M12 3h.01"/>
    <path d="M12 16v.01"/><path d="M16 12h1"/><path d="M21 12v.01"/><path d="M12 21v-1"/>
  </svg>
);
export const CheckInIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
    <polyline points="10 17 15 12 10 7"/>
    <line x1="15" x2="3" y1="12" y2="12"/>
  </svg>
);
export const CheckOutIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/>
    <line x1="21" x2="9" y1="12" y2="12"/>
  </svg>
);
export const ApproveIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
export const RefuseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><line x1="4.93" x2="19.07" y1="4.93" y2="19.07"/>
  </svg>
);
export const EditIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);
export const DeleteIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
  </svg>
);
export const CheckSuccessIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="#52c41a" strokeWidth="1.5"/>
    <path d="M8 12l3 3 5-5" stroke="#52c41a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
export const LogoutIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/>
    <line x1="21" x2="9" y1="12" y2="12"/>
  </svg>
);
